import React, { memo } from 'react';
import Lottie from 'react-lottie';
import tickAnimation from '../../Images/Icons/tick-animation.json';
import errorAnimation from '../../Images/Icons/error-animation.json';

const TickIconDefaultOptions = {
    loop: false,
    autoplay: true,
    animationData: tickAnimation,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

const ErrorIconDefaultOptions = {
    loop: false,
    autoplay: true,
    animationData: errorAnimation,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

const IconAnimation = memo(({ isVerified }) => {
    return (
        <div style={{ height: "6vh",minWidth:"30px" }} className='d-flex justify-conetent-center align-items-center ps-1'>
            {isVerified === true && (
                <Lottie options={TickIconDefaultOptions} height={25} width={25} />
            )}
            {isVerified === false && (
                <Lottie options={ErrorIconDefaultOptions} height={20} width={20} style={{ scale: "1.5" }} />
            )}
        </div>
    );
});

export default IconAnimation;
